/**
 * Created by shem.mahluf on 19/12/2016.
 */
import PropTypes from 'prop-types';

import React from 'react';
import { Link as ReactLink } from 'react-router-dom';
import C_R from '../../../constants/routes';

/**
 * a wrapper around react Link and a regular 'a' tag for navigation outside our app.
 *
 * @param 'to' - string representing a url
 * if it doesn't contain '://' or if it has the same hostname and rootPath as our app
 * it will be treated as an internal route
 * otherwise it will be treated as an external link
 *
 * @param 'target' - string with 2 possible values:
 * '_self' (default) for opening in current window/tab
 * '_blank' for opening in a new window/tab
 */
class DynamicLink extends React.Component {
  parseTo(to) {
    let parser = document.createElement('a');
    parser.href = to;
    return parser;
  }

  isInternal(to) {
    // If it's a relative url such as '/path', 'path' and does not contain a protocol we can assume it is internal.
    if (to.indexOf('://') === -1 && to.indexOf('mailto:') === -1) return true;
    const toLocation = this.parseTo(to);
    return (
      window.location.hostname === toLocation.hostname &&
      toLocation.pathname.indexOf(C_R.SERVICE_PORTAL_PATH) !== -1
    );
  }

  render() {
    const { to, children, target, ...rest } = this.props;
    const toLocation = this.parseTo(to);
    const isInternal = this.isInternal(to);
    if (isInternal) {
      let internalUrl = toLocation.pathname + toLocation.search;

      // fix for IE11 - #28568
      if (internalUrl.charAt(0) !== '/') {
        internalUrl = '/' + internalUrl;
      }

      return (
        <ReactLink to={internalUrl} {...rest}>
          {children}
        </ReactLink>
      );
    } else {
      return (
        <a href={to} target={target} {...rest}>
          {children}
        </a>
      );
    }
  }
}

DynamicLink.propTypes = {
  to: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  children: PropTypes.node
};

DynamicLink.defaultProps = {
  target: '_self'
};

export default DynamicLink;



// WEBPACK FOOTER //
// ./components/utils/DynamicLink/index.js